import { render, staticRenderFns } from "./ProceduresBase.vue?vue&type=template&id=d8c871da"
import script from "./ProceduresBase.vue?vue&type=script&lang=js"
export * from "./ProceduresBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports